export const SET_AUTH_LOGIN = 'SET_AUTH_LOGIN';
export const DEL_AUTH_LOGIN = 'DEL_AUTH_LOGIN';
export const KEY_ACCESSTOKEN = 'KEY_ACCESSTOKEN';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const KEY_REFRESH_TOKEN = 'KEY_REFRESH_TOKEN';
export const SET_AUTH_IS_LOGGED_IN = 'SET_AUTH_IS_LOGGED_IN';
